import ActiveService from '@/service.active';
import {create, update, destroy} from '@/refference.helper';

class BookingService extends ActiveService {
	/**
	 *
	 * @param $injector
	 * @param $auth
	 * @param CONFIG
	 * @param $translates
	 */
	constructor($injector,
	            $auth,
	            CONFIG,
	            $translates,
	            $rootScope,
	            $timeout,
							$upload) {

		'ngInject';

		super($injector);

		this.$auth = $auth;
		this.CONFIG = CONFIG;
		this.$translates = $translates;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$upload = $upload;

		this.dates = {};
		this.operator = [];

		this.next_uri = null;
		this.next_uri_historical = null;
	}

	init() {
		this._initReady$ = this.$q.defer();
		this.initReady$ = this._initReady$.promise;
		this.collections.routes = [];
		this.collections.vehicleBodies = [];
		this.collections.operators = [];
		let deferred = this.$q.defer();
		this.$q.all([
			// this.getBookings(false, manualUrl, params),
			this.getRoutes(),
			this.getVehicleBodies(),
			this.getOperators()
		]).then((data) => {
			create(this.collections.routes, data[0]);
			this.collections.vehicleBodies = data[1];
			this.collections.operators = data[2];
			deferred.resolve();
			this._initReady$.resolve();
		});

		return deferred.promise;
	}

	getSilentScheduleNearestDeparture(route, departureDate) {
    if (!route.schedule) {
      return null
    }
    const schedule = JSON.parse(route.schedule);

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const now = moment();
    const departureDateStr = departureDate.format('YYYY-MM-DD');

    if (now < departureDate) {
      return route.schedule_type === 'daily' ? schedule[departureDateStr][0] : schedule[days[departureDate.day()]][0];
    } else {
      return route.schedule_type === 'daily' ? schedule[departureDateStr].find(t => t > now.format('HH:mm')) : schedule[days[departureDate.day()]].find(t => t > now.format('HH:mm'))
    }
  }

	adjustDepartureDate(booking, route) {
		let h   = booking.departure_hours,
        hm  = (h === '' ? '00:00' : h).split(':');
		if (route.silent_schedule) {
      let departureDate = window.moment(booking.departure_date);
      const nextDepartureTime = this.getSilentScheduleNearestDeparture(route, departureDate);
      if (nextDepartureTime) {
        let hm = nextDepartureTime.split(':');
        departureDate.set({hour: parseInt(hm[0], 10), minute: parseInt(hm[1], 10)});
        booking.departure_date = departureDate.format();
      } else {
        this.notify.set('Brak możliwości rezerwacji w wybranym terminie', 'error');
        return
      }
    } else if (route.operator === 'SCL') {
      const now = window.moment();
      let departureDate = window.moment(booking.departure_date);
      if (now < departureDate) {
        departureDate.set({hour: 9, minute: 0, second: 0});
      } else {
        departureDate = now.add(3, 'hours');
      }

      if (booking.departure_hours !== '') {
        departureDate.set({hour: parseInt(hm[0], 10), minute: parseInt(hm[1], 10)});
      }

      booking.departure_date = departureDate.format();
    } else if (route.operator === 'TALLINK') {
			let departureDate = window.moment(booking.departure_date);
			const timeParts = booking.departure_hours.split(':');
			departureDate.hours(timeParts[0]).minutes(timeParts[1]);
			booking.departure_date = departureDate.format();
		} else {
      booking.departure_date = window.moment(
        booking.departure_date
      )
        .set({hour: parseInt(hm[0], 10), minute: parseInt(hm[1], 10)})
        .format();
    }
		return booking;
	}

	updateTallinkData(booking) {
		const route = angular.copy(booking.route);
		if (route.operator === 'TALLINK') {
      const schedule = route.schedule = JSON.parse(route.schedule);
      const departureDate = moment(booking.departure_date).format('YYYY-MM-DD');
      booking.tallink_route_id = schedule[departureDate].find(el => el.time === booking.departure_hours).id
    }
    return booking;
  }

	multiCreate(booking, adrFile = null, returnRoute = false) {
		let data = [];

		if (Array.isArray(booking)) {
			data = booking;
		} else {
			data.push(booking);
			if (returnRoute) {
				const route = this.collections.routes.find(r => r.uri === booking.route);
				let returnBooking = Object.assign({}, booking);
				returnBooking.route = route.return_route;
				returnBooking = this.adjustDepartureDate(returnBooking, route);
				data.push(returnBooking);
			}
		}

		if (this.mode === 'SPEDITOR') {
			const speditorId = this.$auth.getUser().speditor_id;
			if (!speditorId) {
				this.notify.set(this.$translates.get('ERROR_NO_SPEDITOR_ID'), 'error');
				return;
			}
			data = data.map(b => Object.assign({}, b, {source: 'SpedytorOnline', speditor_id: speditorId}));
		}

		return this.activePost(`${this.$auth.getUser().uri}/multi-booking`, {bookings: data})
			.then(_bookings => {
				_bookings.onPush = true;
				this.$timeout(() => {
					this.$rootScope.$emit('$bookingsUnshift', _bookings);
					const bookingCost = _bookings.reduce((prev, cur) => prev + cur.actual_booking_value, 0);
					this.$rootScope.$emit('bookingLimitComponentUpdateValue', {
						method: "create",
						actual_booking_value: bookingCost
					});
				}, 0);

				if (adrFile) {
					const uris = _bookings.map(b => b.uris.BookingFiles);
					uris.forEach(uri => this.$upload.upload(uri, adrFile));
				}
			})
			.then(() => this.notify.set(this.$translates.get('BOOKING_CREATE_SUCCESS'), 'success'))
			.catch(response => {
				if (response.status === 409) {
					this.notify.set(this.$translates.get('BOOKING_CREATE_CATCH_LIMIT'), 'error')
				}
				if (response.status === 400) {
					this.notify.set(this.$translates.get(response.data.reason), 'error')
				}
			});

	}


	create(booking) {
		return this.activePost(this.$auth.getUser().uris.Bookings, booking)
			.then(_booking => {
				_booking.onPush = true;
				this.$timeout(() => {
					// this.$rootScope.$emit('$bookingsUnshift', _booking);
					this.$rootScope.$emit('bookingLimitComponentUpdateValue', {
						method: "create",
						actual_booking_value: _booking.actual_booking_value
					});
				}, 0);
			})
			.then(() => this.notify.set(this.$translates.get('BOOKING_CREATE_SUCCESS'), 'success'))
			.catch(response => {
				if (response.status === 409) {
					this.notify.set(this.$translates.get('BOOKING_CREATE_CATCH_LIMIT'), 'error')
				}
			});
	}

	update(booking) {
		return this.activePut(booking.uri, booking)
			.then(_booking => {
				update(booking, _booking);
				this.notify.set(this.$translates.get('BOOKING_UPDATE_SUCCESS'), 'success');
				return _booking;
			})
			.catch(response => {
				console.log(response);
				this.notify.set(response.data.reason || 'Coś poszło nie tak', 'error')
			});
	}

	destroy(booking) {
		return this.activeDelete(booking.uri)
			.then(() => booking.booking_status = 1)
			.then(() => this.notify.set(this.$translates.get('BOOKING_DESTROY_SUCCESS'), 'success'))
	}

	/**
	 *
	 * @param id
	 * @returns {*}
	 */
	getBooking(id) {
		let deferred = this.$q.defer(),
			result = () => deferred.resolve(this.bookings.filter(booking => booking.id == id)[0]);
		try {
			result();
		} catch (e) {
			this.init().then(() => result());
		}
		return deferred.promise;
	}

	getEmptyBookings() {
		this.collections.bookings = [];
		create(
			this.collections.bookings,
			[]
		);
	}

	/**
	 *
	 * @returns {*|Promise.<TResult>}
	 */
	getBookings(scroll, manualUrl, params) {
		this.loading = true;
		if (!scroll) {
			this.collections.bookings = [];
		}
		if (params.next_uri === false && scroll) {
			return false;
		}

		params.filter = {};

		if (this.dates.dateTo && this.dates.dateFrom) {
			params.filter = {
				'departure_date <= ': this.dates.dateTo,
				'departure_date >= ': this.dates.dateFrom,
			}
		}
		if (params.route_operator && params.route_operator.length >= 1) {
			if (params.route_operator.length === 1) {
				params.filter['route_operator'] = params.route_operator[0];
			} else {
				params.filter['_route_operator'] = params.route_operator.join('|');
			}
		}

		let url = this.$auth.getUser().uris.Bookings;

		return this.$search(url, params)
			.then(bookings => {

				this.next_uri = bookings.next_uri ? bookings.next_uri : false;
				bookings.objects = this.secondLevelSort(bookings.objects, params.order);

				if (this.mode !== 'SPEDITOR') {
					create(
						this.collections.bookings,
						bookings.objects
					);
				}
				this.loading = false;
				setTimeout(() => window.dispatchEvent(new Event('resize')));
			});

	}

	getHistoricalBookings(scroll, manualUrl, params) {

		if (!scroll) {
			this.collections.historicalBookings = [];
		}
		if (params.next_uri_historical === false && scroll) {
			return false;
		}

		if (this.dates.dateTo && this.dates.dateFrom) {
			params.filter = {
				'departure_date <= ': this.dates.dateTo,
				'departure_date >= ': this.dates.dateFrom,
			}
		}
		if (params.route_operator && params.route_operator.length === 1) {
			params.filter['route_operator'] = params.route_operator[0];
		}

		let url = `${this.$auth.getUser().uri}/historical-bookings`;

		return this.$search(url, params)
			.then(bookings => {

				this.next_uri_historical = bookings.next_uri ? bookings.next_uri : false;

				bookings.objects = this.secondLevelSort(bookings.objects, params.order);

				if (this.mode !== 'SPEDITOR') {
					create(
						this.collections.historicalBookings,
						bookings.objects
					);
				}

			});

	}

  getManagerBookings(scroll, manualUrl, params) {

		if (!scroll) {
			this.collections.managerBookings = [];
		}
		if (params.next_uri_manager === false && scroll) {
			return false;
		}

		if (this.dates.dateTo && this.dates.dateFrom) {
			params.filter = {
				'departure_date <= ': this.dates.dateTo,
				'departure_date >= ': this.dates.dateFrom,
			}
		}
		// if (params.route_operator && params.route_operator.length === 1) {
		// 	params.filter['route_operator'] = params.route_operator[0];
		// }

		let url = `${this.$auth.getUser().uri}/manager-bookings`;

		return this.$search(url, params)
			.then(bookings => {

				this.next_uri_manager = bookings.next_uri ? bookings.next_uri : false;

				bookings.objects = this.secondLevelSort(bookings.objects, params.order);

				if (this.mode !== 'SPEDITOR' && this.mode !== 'STANDARD') {
					create(
						this.collections.managerBookings,
						bookings.objects
					);
				}

			});

	}

	/**
	 *
	 * @returns {*|Promise.<TResult>}
	 */
	getRoutes() {
		return this.activeGet(this.CONFIG.API.routes)
			.then(routes => routes.filter(r => !r.archived).sort((a, b) => a.order - b.order));
	}

	getOperators() {
		return this.activeGet(this.CONFIG.API.operators)
			.then(routes => routes.sort((a, b) => a.operator_display_name - b.operator_display_name));
	}

	getBookingConfirmation(bookings) {
		let url = `${this.$auth.getUser().uri}/booking-confirmation`;
		const data = {"booking_uris": bookings};
		return this.activePost(url, data, { responseType: 'blob' })
	}

	getCompanyByNip(nip) {
		let url = `/api/company-by-nip`;
		const data = {"nip": nip};
		return this.activePost(url, data)
	}

	/**
	 *
	 * @returns {*|Promise.<TResult>}
	 */
	getVehicleBodies() {
		const poTypes = ['tt', 'van', 'lorry', 'st'];

		const irishVB = [
			{
				id: 1,
				name: 'AR',
				length: 16.5,
				weight: 24,
				minLength: 14,
				maxLength: 17
			},
			{
				id: 2,
				name: 'RD',
				length: null,
				weight: null,
				minLength: 1,
				maxLength: 12
			},
			{
				id: 3,
				name: 'RT',
				length: 18,
				weight: 24,
				minLength: 18,
				maxLength: 19
			}
		];

		const poferriesVB = [
			{
				id: 1,
				name: 'Vehicle',
				length: 16.5,
				// weight: 24,
				// minLength: 14,
				// maxLength: 17
			},
			{
				id: 2,
				name: 'Trailer',
				length: 13.6,
				// weight: 24,
				// minLength: 14,
				// maxLength: 17
			},
			{
				id: 3,
				name: 'Tanker',
				length: 15,
				// weight: 24,
				// minLength: 14,
				// maxLength: 17
			},
			{
				id: 4,
				name: 'Tractor',
				length: 6,
				// weight: 24,
				// minLength: 14,
				// maxLength: 17
			},

		];

		const tallinkVB = [
			{
				id: 1,
				name: 'BPP',
				length: 16.5,
				weight: 24,
				minLength: 10,
				maxLength: 58
			},
			{
				id: 2,
				name: 'BPO',
				length: 7,
				weight: 24,
				minLength: 6,
				maxLength: 14
			},
			{
				id: 3,
				name: 'TE',
				length: 10,
				weight: 24,
				minLength: 5,
				maxLength: 40
			},
			{
				id: 4,
				name: 'CH',
				length: 10,
				weight: 24,
				minLength: 3,
				maxLength: 27
			}
		]

		const vehicleBodies = {
			'DFDS': [
				{
					id: 1,
					name: 'package',
					length: 16.5,
					weight: 24
				},
				{
					id: 2,
					name: 'roadtrain',
					length: 19,
					weight: 24
				},
				{
					id: 3,
					name: 'other',
					length: null,
					weight: null
				}
			],
			'UNITYLINE': [
				{
					id: 1,
					name: 'package',
					length: 16.5,
					weight: 24
				},
				{
					id: 2,
					name: 'roadtrain',
					length: 19,
					weight: 24
				},
				{
					id: 3,
					name: 'other',
					length: null,
					weight: null
				}
			],
			'JHFERRY': [
				{
					id: 1,
					name: 'package',
					length: 16.5,
					weight: 24
				},
				{
					id: 2,
					name: 'roadtrain',
					length: 19,
					weight: 24
				},
				{
					id: 3,
					name: 'other',
					length: null,
					weight: null
				}
			],
			'MOVEEXPERT': [
				{
					id: 1,
					name: 'other',
					length: 7,
					weight: null,
					minLength: 0,
					maxLength: 12
				}
			],
			'PO': poferriesVB,
			'TSF': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'TSF_IRISH': [
				{
					id: 1,
					name: 'van',
					length: 7,
					weight: null,
					minLength: 0,
					maxLength: 8
				}
			],
			'TSF_IRISH_CZ': [
				{
					id: 1,
					name: 'van',
					length: 7,
					weight: null,
					minLength: 0,
					maxLength: 8
				}
			],
			'EUROTUN': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'EUROTUN_CZ': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'SCL': [
				{
					id: 1,
					name: 'FGTVAN',
					length: 7,
					weight: 24,
					minLength: 0,
					maxLength: 9.5
				},
				{
					id: 2,
					name: 'LORRY',
					length: 16.5,
					weight: 24,
					minLength: 10,
				}],
			'ORESUND': [{
				id: 1,
				name: 'LORRY',
				length: 16.5,
				weight: 24,
				minLength: 9.1,
				maxLength: 17
			},
			{
				id: 2,
				name: 'OTHER',
				length: 7,
				weight: 24,
				minLength: 5,
				maxLength: 9
			}],
			'STOREBELT': [{
				id: 1,
				name: 'lorry',
				length: 16.5,
				weight: 24
			}],
			'IRISH': irishVB,
			'IRISH_CZ': irishVB,
			'TALLINK': tallinkVB,
			'POFERRIES': poferriesVB,
			'MONTBLANC': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'MONTBLANC_XLS': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'MONTBLANC_CZ': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'FREJUS': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'FREJUS_XLS': Array.from(new Array(poTypes.length).keys()).map(n => {``
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
		  'FREJUS_CZ': Array.from(new Array(poTypes.length).keys()).map(n => {
				return {
					id: n + 1,
					name: poTypes[n],
					length: null,
					weight: null
				}
			}),
			'POLFERRIES_EMAIL': [
				{
					id: 1,
					name: 'other',
					length: null,
					weight: null
				}
			],
			'UNITYLINE_EMAIL': [
				{
					id: 1,
					name: 'other',
					length: null,
					weight: null
				}
			],
			'POLSCA_EMAIL': [
				{
					id: 1,
					name: 'other',
					length: null,
					weight: null
				},
				{
					id: 2,
					name: 'trailer',
					length: 14,
					weight: null,
					trailer: true,
				}
			],
			'ASTAADRIA': [
				{
					id: 1,
					name: 'VAN',
					length: 7,
					weight: 5,
					minLength: 0,
					maxLength: 7
				},
				{
					id: 2,
					name: 'LORRY',
					length: 8,
					weight: 20,
					minLength: 7.49,
					maxLength: 15
				},
				{
					id: 3,
					name: 'ARTIC',
					length: 15,
					weight: 24,
					minLength: 15,
					maxLength: 17
				},
				{
					id: 4,
					name: 'ROADTRAIN',
					length: 18,
					weight: 24,
					minLength: 18,
					maxLength: 18
				},
			],
			"FREIGHT_FERRY": [
				{
					id: 1,
					name: 'Trucktrailer',
					length: 16.5,
					weight: 5,
					minLength: 15.1,
					maxLength: 17
				}
			],
			"FREIGHT_FERRY_IRISH": [
				{
					id: 1,
					name: 'Trucktrailer',
					length: 16.5,
					weight: 5,
					minLength: 15.1,
					maxLength: 17
				}
			]
		};
		let deferred = this.$q.defer();
		deferred.resolve(vehicleBodies);
		return deferred.promise;
	}

	get mode() {
    return this._mode;
  }

  setMode(mode) {
    this._mode = mode;
    if (this._mode === 'SPEDITOR') {
      this.$rootScope.$emit('refreshSpeditorBookings');
    } else if (this._mode === 'MANAGER') {
      this.$rootScope.$emit('refreshManagerBookings');
		} else {
			this.$rootScope.$emit('refreshStandardBookings');
		}
    setTimeout(() => window.dispatchEvent(new Event('resize')));
  }

  secondLevelSort(objects, sort) {
		const sortProp = sort || 'departure_date';
		const absSortProp = sortProp[0] === '-' ? sortProp.substring(1) : sortProp;
		const _objects = objects.sort((a, b) => {
			if (a[absSortProp] === b[absSortProp]) {
				if (sortProp[0] === '-') {
					return moment(a.created).unix() - moment(b.created).unix();
				} else {
					return moment(b.created).unix() - moment(a.created).unix();
				}
			} else {
				return true;
			}
		});
		return _objects;
	}

  getLimitTest(taxNumber) {
		const url = 'https://limity.skatstatus.pl:8104/Contractors/limit';
		return this.activePostDirect(url, {taxNumber});
	}

	getUploadedVehicles() {
    return this.activeGet(this.$auth.company.uris.UploadedVehicles);
  }

}

export default BookingService;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking.service.js
 **/